var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStrokeOnDarkBlueHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.4841 9.18595L14.1974 1L26 9.18595L22.1093 11.7793M2.4841 9.18595V13.3686M2.4841 9.18595L6.25461 11.6136M2.4841 13.3686L1 19.6872H3.77778L2.4841 13.3686ZM6.25461 11.6136L14.1974 17.0619L22.1093 11.7793M6.25461 11.6136L6.12771 18.9655C6.10841 20.0834 7.00934 21 8.12741 21H20.1093C21.2139 21 22.1093 20.1046 22.1093 19V11.7793",
    stroke: "#00B0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrokeOnDarkBlueHat);
export default __webpack_public_path__ + "static/media/stroke-on-dark-blue-hat.ec17b004767fbdea92076754bc9db120.svg";
export { ForwardRef as ReactComponent };